import React from 'react';
import PropTypes from 'prop-types';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange({ target }) {
    const { value, name } = target;
    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    const { onFormSubmit } = this.props;
    event.preventDefault();
    onFormSubmit(this.state);
  }

  render() {
    return (
      <div>
        <section className="theme-dark form-header">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>Complete this Form to get your Personalized Results Report</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="contact-form">
          <div className="row">
            <div className="col-md-6 col-md-offset-3">
              <form onSubmit={this.handleSubmit} className="contactform" id="contactform">
                <div className="row">
                  <div className="form-group col-md-6">
                    <label htmlFor="contactform__firstname">First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      className="form-control contactform__firstname"
                      id="contactform__firstname"
                      placeholder="Required field"
                      required
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="contactform__lastname">Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      className="form-control contactform__lastname"
                      id="contactform__lastname"
                      placeholder="Required field"
                      required
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label htmlFor="contactform__role">Role</label>
                    <select
                      name="role"
                      className="form-control contactform__role"
                      id="contactform__role"
                      required
                      onChange={this.handleChange}
                    >
                      <option value="">Required field</option>
                      <option value="CIO">CIO</option>
                      <option value="CTO">CTO</option>
                      <option value="CEO">CEO</option>
                      <option value="Enterprise Architect">Enterprise Architect</option>
                      <option value="Software Developer">Software Developer</option>
                      <option value="Management (Software Development)">
                        Management (Software Development)
                      </option>
                      <option value="Management (IT/Ops)">Management (IT/Ops)</option>
                      <option value="Security Team">Security Team</option>
                      <option value="Product Team">Product Team</option>
                      <option value="Marketing">Marketing</option>
                      <option value="Data Team">Data Team</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="contactform__company">Company</label>
                    <input
                      type="text"
                      name="company"
                      className="form-control contactform__company"
                      id="contactform__company"
                      placeholder="Required field"
                      required
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label htmlFor="contactform__email">Work Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control contactform__email"
                      id="contactform__email"
                      placeholder="Required field"
                      required
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="contactform__phone">Phone</label>
                    <input
                      type="text"
                      name="phone"
                      className="form-control contactform__phone"
                      id="contactform__phone"
                      placeholder="Required field"
                      required
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-12">
                    <input
                      type="checkbox"
                      name="consent"
                      className="contactform__consent"
                      id="contactform__consent"
                      required
                      value="true"
                      onChange={this.handleChange}
                    />
                    <label htmlFor="contactform__consent">
                      I agree to receive content via email from Auth0
                    </label>
                  </div>
                </div>
                <div className="cta-action text-center">
                  <button className="btn btn-lg btn-success contactform__submit animated">
                    Get results
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

Form.propTypes = {
  onFormSubmit: PropTypes.func.isRequired
};

Form.defaultProps = {};

export default Form;



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/Form/Form.js